export default "__VITE_ASSET__6h3O9vOR__"